import * as BABYLON from "babylonjs";

import {Scene, MeshBuilder, AssetsManager, AssetContainer} from "babylonjs";
import {BaseManager} from "./BaseManager";
import {IManager} from "./IManager";

interface AssetContainerDictionary {
    [index: string]: AssetContainer;
}

export class SceneManager extends BaseManager implements IManager {

    scene:Scene|null = null;

    defaultSceneName:string = 'DefaultScene';

    containers:AssetContainerDictionary = {};

    async init() {

        let sceneName = this.defaultSceneName;
        let s = this;

        let scene = await this.loadSceneByName(sceneName).then(function() {
            s.viewer.InputHandler.listen();
        });

        return scene;
    }

    addCameraToScene(camera: BABYLON.Nullable<BABYLON.Camera>) {
        this.scene.activeCamera = camera;
        console.log('addCameraToScene');
        console.debug(camera);
        this.scene.activeCamera.attachControl(this.viewer.canvas, true);
    }

    createNewScene() {
        return new Scene(this.viewer.engine);
    }

    async loadSceneByName(name: string) {
        let Scene = this.scene = this.createNewScene();

        /**
         * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/assetManager
         */
        this.viewer.AssetsManager = new AssetsManager(Scene);

        /**
        let gravityVector = new BABYLON.Vector3(0,-9.81, 0);
        Scene.enablePhysics(gravityVector);
        */
        //Scene.enablePhysics(null, new BABYLON.CannonJSPlugin());
        /*
        Scene.debugLayer.show({
            embedMode: true,
        });

         */
        await this.importByName(name, 'Scenes');
    }

    createContainer(name: string)
    {
        /**
         * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/assetContainers
         */
        this.containers[name] = new AssetContainer(this.scene);
        return this.containers[name];
    }
}